import { camelize } from 'humps';

import { HateoasLinksType } from 'types';

export const getHasHateoasAccess = (
  rel: string,
  __links: HateoasLinksType | undefined | null,
) => __links?.some(link => camelize(link.rel) === rel) || false;
